<template>
    <div class="materialMgt bgc box-shadow">
        <div class="content_box">
            <router-view></router-view>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {}
    },
    methods: {},
    mounted() {}
}
</script>
<style lang="scss" type="text/scss" rel="stylesheet/scss" scope>
.materialMgt {
    padding-bottom: 50px;
    min-width: 1240px;
}
</style>